import styled from 'styled-components'

import { Button } from 'components/Button/Button'
import { IconAlertBig } from 'components/Icons/IconAlertBig'
import { IconPlus } from 'components/Icons/IconPlus'
import { Typography } from 'components/Typography/Typography'
import { useIsMobile } from 'utils/useIsMobile'
import { DONT_SHOW_THIS_AGAIN_LP_LS_KEY } from './LpVaultDetails'
import { useCurrentWalletAddress } from 'utils/useCurrentWalletAddress'

const PositionContainer = styled.div`
  text-align: center;
  padding: 40px;
  border-radius: 16px;
  border: 0.7px solid ${p => p.theme.colors.divider};
  background: ${p => p.theme.colors.background.primary};
  box-shadow: 0px 0px 16px 0px ${p => p.theme.colors.background.hover};
  svg {
    margin-left: 8px;
  }

  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    padding: 24px;
  }
`

interface Props {
  onNewPositionClick: () => void
  newPositionDisabled: boolean
}

export const NoAvailablePosition = ({ onNewPositionClick, newPositionDisabled }: Props) => {
  const isMobile = useIsMobile()

  const explanationDisplayed =
    localStorage.getItem(DONT_SHOW_THIS_AGAIN_LP_LS_KEY) === 'false' ||
    !localStorage.getItem(DONT_SHOW_THIS_AGAIN_LP_LS_KEY)

  const walletAddress = useCurrentWalletAddress()
  const isConnected = !!walletAddress

  return (
    <PositionContainer style={{ marginTop: explanationDisplayed ? '24px' : '24px' }}>
      <IconAlertBig width={isMobile ? 40 : undefined} height={isMobile ? 40 : undefined} />
      <Typography variant={isMobile ? 'description' : 'label1'} fontWeight="bold" style={{ margin: '16px 0' }}>
        No Available Positions
      </Typography>
      <Typography variant={isMobile ? 'caption' : 'label2'} fontWeight="light">
        Create new position to add
      </Typography>
      <Button
        style={{ display: 'flex', alignItems: 'center', margin: 'auto', marginTop: 16 }}
        onClick={onNewPositionClick}
        disabled={!isConnected || newPositionDisabled}
      >
        New Position <IconPlus />
      </Button>
    </PositionContainer>
  )
}
